module.exports = __webpack_public_path__ + "img/qrcode.b9c477b2.jpg";